/**
 * Converte valor monetário BR/US em número.
 * - "696,25"  → 696.25
 * - "696.25"  → 696.25  (ponto decimal — NÃO vira 69625)
 * - "1.234,56" → 1234.56
 */
export function parseValorMoedaBr(raw) {
  if (raw == null || raw === '') return null;
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw;

  let s = String(raw).replace(/[^\d,.-]/g, '').trim();
  if (!s) return null;

  const negative = s.startsWith('-');
  if (negative) s = s.slice(1);

  const hasComma = s.includes(',');
  const hasDot = s.includes('.');

  if (hasComma && hasDot) {
    if (s.lastIndexOf(',') > s.lastIndexOf('.')) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else {
      s = s.replace(/,/g, '');
    }
  } else if (hasComma) {
    s = s.replace(',', '.');
  } else if (hasDot) {
    const parts = s.split('.');
    if (parts.length === 2 && parts[1].length <= 2) {
      s = `${parts[0]}.${parts[1]}`;
    } else {
      s = parts.join('');
    }
  }

  const n = Number.parseFloat(negative ? `-${s}` : s);
  return Number.isFinite(n) ? n : null;
}

export function formatCurrencyBr(v) {
  const n = typeof v === 'number' ? v : parseValorMoedaBr(v);
  if (n == null || Number.isNaN(n)) return '—';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n);
}
